import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ContactChatRoom } from "@/components/features-new/contact/chat-room";

import { useContactChatRoomPageParams } from "./hooks";

export const ContactChatRoomPage = () => {
	const { hotelID, contactID } = useContactChatRoomPageParams();

	return (
		<PageMeta title="お問い合わせ詳細" url={generatePath(PATHS.HOTEL.CONTACT.CHAT_ROOM, { hotelID, contactID })}>
			<ContactChatRoom hotelID={hotelID} contactID={contactID} />
		</PageMeta>
	);
};

ContactChatRoomPage.displayName = "ContactChatRoomPage";
